<template>
    <b-row class="mb-5 font-weight-light">
        <b-col>
            <b-link class="text-dark">Mentions légales et CGU</b-link><br />
            <b-link class="text-dark">Protection des données personnelles</b-link><br />
            <b-link class="text-dark">Gestion des cookies</b-link>
        </b-col>
        <b-col class="text-right text-dark">
            &copy;{{ date }} CPAM77 / v{{ $config.VERSION }}
        </b-col>
    </b-row>
</template>

<script>
export default {
    name: 'Footer',
    computed: {
        date() {
            let d = new Date();
            return d.getFullYear();
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue